export default __webpack_public_path__ + "img/476c5beff833217696afe1285451ba08.png";